import { neutral } from '../global';
export const brandAltLine = {
    primary: neutral[7],
};
//# sourceMappingURL=brand-alt.js.map
